var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"card col-md-12"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-body"},[_c('esta_segui_covid')],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }